import "../styles/main.scss";

import { Core } from "@unseenco/taxi";
import RendererDefault from "./modules/transitions/renderers.js";
import TransitionDefault from "./modules/transitions/transitions.js";

export const taxi = new Core({
	renderers: {
		default: RendererDefault,
	},
	transitions: {
		default: TransitionDefault,
	},
});

// taxi.on('navigate', function (route) {
// 	console.log(route.query)
// 	if (route.query && route.query['data-name'] === 'landing-page') {
// 		window.location.reload(true);
// 	}
// });
// 
// taxi.on('beforeLeave', function (route) {
// 	console.log(route.query)
// 	if (route.query && route.query['data-name'] === 'landing-page') {
// 		window.location.reload(true);
// 	}
// });


taxi.on('NAVIGATE_IN', ({ to, trigger }) => {
	if (to.content.attributes["data-name"].value === 'landing-page') {
		window.location.reload(true);
	}
})
taxi.on('NAVIGATE_END', ({ from, trigger }) => {
	if (from.content.attributes["data-name"].value === 'landing-page') {
		window.location.reload(true);
	}
})